module.exports = __webpack_public_path__ + "img/evtools-dark.bb7b8036.png";